import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

let client: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient | null {
  if (!url || !anon) return null;
  if (!client) {
    client = createClient(url, anon, {
      auth: { persistSession: false },
    });
  }
  return client;
}

export const SUPABASE_URL = url ?? "";
export const SUPABASE_ANON_KEY = anon ?? "";
export const isSupabaseConfigured = Boolean(url && anon);

/**
 * Compteur live "X personnes ont fait le quiz".
 * Utilise la fonction RPC `count_leads` (security definer) pour ne pas exposer la table en lecture.
 */
export async function fetchLeadCount(): Promise<number | null> {
  const sb = getSupabase();
  if (!sb) return null;
  try {
    const { data, error } = await sb.rpc("count_leads");
    if (error) return null;
    if (typeof data === "number") return data;
    if (typeof data === "string") return Number(data);
    return null;
  } catch {
    return null;
  }
}
